import VueRouter from 'vue-router';
//Pages
import AdminLoading from "./views/admin-loading.vue";
import ContextCheck from "./views/context-check.vue";
const AdminLogin = () => import("./views/admin-login.vue");
const AdminRegister = () => import("./views/admin-register.vue");
const AdminConsole = () => import("./views/admin-console.vue");

const TenantDash = () => import("./views/tenant-dash.vue");

import { CrudRouter, Tree, AutoRouter } from "javaee-fre";
import { independentRegionTree } from "./routers/comm-func.js";

import Sys from "./routers/sys-router.js";
import Mo from "./routers/mo-router.js";
import Comm from "./routers/comm-router.js";
import Clazz from "./routers/clazz-router.js";
import Stu from "./routers/stu-router.js";
import Price from "./routers/price-router.js";
import Org from "./routers/org-router.js";
import Room from "./routers/room-router.js";
import Module from "./routers/module-router.js";
import ShortVideo from "./routers/short-video-router.js";

const routes = [
    { path: '*', component: AdminLoading },
    { path: '/ctxcheck', component: ContextCheck },
    { path: '/login', component: AdminLogin },
    { path: '/register', component: AdminRegister },
    {
        path: '/console', component: AdminConsole, meta: { name: '我的' },
        children: [
            ...Sys.routers,
            ...Clazz.routers,
            ...Stu.routers,
            ...Price.routers,
            ...Org.routers,
            ...Mo.routers,
            ...Comm.routers,
            ...Room.routers,
            ...Module.routers,
            ...ShortVideo.routers,
            {
                path: 'home/admin/my/tenant/acc', component: CrudRouter, meta: {
                    listItemActions: [{
                        label: '修改密码', icon: 'vpn_key', func(cfg) {
                            this.$parent.onEdit(cfg.item.id, { _chgpwd: true });
                        }
                    }, {
                        label: '解除登录锁定', icon: 'lock_open', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/acc/unlock/${cfg.item.id}`).then(() => {
                                self.refresh();
                            });
                        }
                    }],
                    listItemFilter(i, acts) {
                        if (!i.lock) {
                            this.delAction(acts, "icon", "lock_open");
                        }
                        return acts;
                    }
                }
            },
            {
                path: 'home/admin/my/tenant/dict', component: AutoRouter, meta: {
                    drawerWidth: 200,
                    tree: {
                        url(i) {
                            return i ? `/home/admin/my/tenant/dict/list/0/1000?${i.label ? ('_cate=' + i.val) : ('_parentId=' + i.id)}` : '/home/admin/my/tenant/dict/dict/category';
                        },
                        label(i) {
                            return i.name || i.label;
                        },
                        id(i) {
                            return i.name ? i.id : `c_${i.val}`
                        },
                        hasChildren(i) {
                            return i.label ? true : false;
                        }
                    },
                    crud: {
                        url: '/home/admin/my/tenant/dict',
                        desc: '<p class="sys-alert">字典一旦创建不能删除和修改，请认真确认之后创建。</p>',
                        genParams(i) {
                            return i.name ? { _parentId: i.id } : { _cate: i.val };
                        }
                    }
                }
            },
            {
                path: 'home/admin/my/tenant/monitor', component: CrudRouter, meta: {
                    listItemActions: [{
                        label: '修改密码', icon: 'vpn_key', func(cfg) {
                            this.$parent.onEdit(cfg.item.id, { _chgpwd: true });
                        }
                    }],
                    onEditSelect(e) {
                        let self = this;
                        if (e.field != 'region') {
                            return;
                        }
                        self.$dialog.component('选择行政区划', Tree, { width: 300, ...independentRegionTree() },
                            [{
                                label: '确认设置', func(sel) {
                                    if (!sel || !sel.actived) { return }
                                    e.cb(sel.actived.fullname, sel.actived.id);
                                }
                            }]);
                    }
                }
            },
            {
                path: 'home/admin/my/tenant/dash', component: TenantDash
            },
            {
                path: 'home/admin/my/tenant/clz_stu_tag', component: CrudRouter
            }
        ]
    }
];

const router = new VueRouter({
    routes
});
//重新定义一下push，带上title
router._push = router.push;
router.push = function (path, title) {
    this._push(path);
    this._lastTitle = title;
}

export default {
    use(Vue) {
        Vue.use(VueRouter);
        return router;
    }
};
